





























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { IOption } from '@/types/comparison';

@Component
export default class ComparisonConfig extends Vue {
  @Prop() private currentOptions: any;
  @Prop() private optSource: any;
  @Getter('durationTime') private durationTime: any;
  @Getter('comparisonStore/ChangeType') private changeType: any;

  private changOption(item: IOption, key: string) {
    this.$store.dispatch('comparisonStore/SELECT_CONFIG', {
      duration: this.durationTime,
      type: key,
      option: item,
    });
  }

  private updateChart() {
    this.$store.dispatch('comparisonStore/RENDER_CHART', this.durationTime);
  }

  private resetService() {
    this.$store.commit('comparisonStore/SET_ISPREVIOUS', 'init');
    this.$store.dispatch('comparisonStore/GET_SERVICES', {duration: this.durationTime});
  }
}
